import * as React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';

import SliderWithSFX from './SliderWithSFX';

function SliderSFXDemo() {
  return (
    <Demo
      id="slider-sfx-demo"
      initialValues={{
        mode: 'single-sample',
      }}
      outputWrapper={null}
      controlPosition="top"
      controls={[
        <DemoToggleButtonGroupControl
          key="mode"
          id="mode"
          label="Mode"
          options={[
            {
              label: 'Single sample',
              value: 'single-sample',
            },
            {
              label: 'Multiple samples',
              value: 'multi-samples',
            },
          ]}
        />,
        ,
      ]}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
    >
      {({ mode }) => {
        return (
          <Wrapper>
            <SliderWithSFX mode={mode} />
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  padding-top: 24px;

  @media ${BREAKPOINTS.smAndSmaller} {
  }
`;

export default SliderSFXDemo;
